import React, {Fragment, useState} from 'react';
import { withStyles, Typography } from '@material-ui/core';
import { Col, Row } from 'react-flexbox-grid';
import ObjectiveProject from './objectiveProject';
import IndicatorTypeFilters from './indicatorTypeFilters';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import SimpleMenuBar from '../menuBar/simpleMenuBar';
import ListAllResearchers from '../researchers/listAllResearchers';
import StaticContent from '../static';

const styles = theme => ({
    root: {
        paddingTop : 30,
        paddingRight : 70,
        paddingLeft : 70,
        paddingBottom : 70,
        textAlign: 'center',
        borderRadius : 0,
        height : "100%",
        minHeight : "100%"
    },
    content: {
        padding: 12,
    },
    row: {
        justifyContent: 'center',
    },
    text : {
        color : '#0D6939',
        fontFamily : "'Poppins', sans-serif"
    },
    contentTitle : {
        width : "100%",
        justifyContent : 'center',
        alignItems : 'center',
        display : 'flex',
        marginTop : 0
    },
    title : {
        fontFamily : "'Poppins', sans-serif"
    }
});

const GET_INDICATOR_TYPES = gql`
  {
    allIndicatorTypes {
      _id
      name
      description
      image
    }
  }
`;

const InitialContent = ({classes}) => (
    <Query query={GET_INDICATOR_TYPES}>
        {({ loading, error, data }) => {
            return(
                <Fragment>
                    <Row className={classes.row}>
                        <div className={classes.contentTitle}>
                            <Typography variant="h4" align="center" className={classes.title}>
                                Atlas de la salud de Colombia
                            </Typography>
                        </div>
                        <Col xs={12} md={12} className={classes.content}>
                            <ObjectiveProject />
                            <IndicatorTypeFilters
                                data    = {data}
                                loading = {loading}
                            />
                        </Col>
                    </Row>
                </Fragment>
            )
        }}
    </Query>
);

const getContent = (
        content,
        classes,
    ) => {
    switch(content){
        case 'LANDING' : 
            return (
                <InitialContent classes={classes}/>
            );
        case 'RESEARCHERS' :
            return(
                <ListAllResearchers/>
            )
        default :
            return(
                <StaticContent page={content}/>
            )   
    }
};

/**
 * Contenedor de vistas
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const ViewContainer = ({ classes }) => {
    const [content, setContent] = useState('LANDING');

    const selectedMenuItem = (item) => {
        setContent(item);
    }

    return (
        <Fragment>
            <SimpleMenuBar selectedMenuItem={(item) => selectedMenuItem(item)} />
            <div className={classes.root}>
                {getContent(content, classes)}
                <div className="md:flex items-center justify-center mt-8">
                    <div>
                        <div className="flex justify-center">
                            <img 
                                src="https://vgde-files.s3.amazonaws.com/LogoFacultadNacionaldeSaludPublica.png" 
                                alt="logo"
                                width="150" 
                                height="40"
                            />
                        </div>
                        <Typography className={classes.text} variant="caption" display="block" style={{fontSize : 9}}>Grupo de Investigación de Epidemiología</Typography>
                    </div>
                    <div>
                        <div className="flex justify-center">
                            <img 
                                style={{backgroundSize : "cover"}}
                                src="https://vgde-files.s3.amazonaws.com/OPS_OMS.png" 
                                alt="logo"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
};

ViewContainer.propTypes = {
    classes : PropTypes.object,
}

export default withStyles(styles)(ViewContainer);


// WEBPACK FOOTER //
// ./src/components/landing-page/viewContainer.js